var _defs, _path, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_play_Icon",
    "data-name": "Google play Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.988,
    height: 28.455,
    viewBox: "0 0 86.988 28.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M147.333,336.795l-3.922-2.265-7.566-4.368c-.42-.243-.838-.1-.838.411v17.8c0,.38.3.544.664.333l7.74-4.469,3.922-2.265,3.77-2.177c.442-.256.4-.606.027-.807S147.333,336.795,147.333,336.795Z",
    transform: "translate(-135.006 -330.047)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006aa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#2f8da6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#66b6ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7cc6af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab59d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfe385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4282d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#ba2d4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#83357b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e388d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f07165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#faa460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffba5e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M183.629,320.684a3.845,3.845,0,0,1-3.844,3.846h-79.3a3.846,3.846,0,0,1-3.845-3.846V299.92a3.846,3.846,0,0,1,3.845-3.846h79.3a3.845,3.845,0,0,1,3.844,3.846Z",
    transform: "translate(-96.641 -296.074)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLAY",
    transform: "translate(6.525 5.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M135.006,328.285v19.27l9.717-9.635Z",
    transform: "translate(-135.006 -328.585)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M147.333,334.99l-3.922-2.265-8.4-4.853v.07l9.717,9.635Z",
    transform: "translate(-135.006 -328.243)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M135.006,394.572v.07l8.4-4.853,3.922-2.264-2.61-2.588Z",
    transform: "translate(-135.006 -375.602)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M194.749,369.721l-2.61,2.588,2.61,2.588,4.483-2.588Z",
    transform: "translate(-182.423 -362.973)",
    fill: "url(#linear-gradient-4)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336",
    transform: "translate(65.091 10.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M481.975,378.741a2.423,2.423,0,0,1-1-.2,1.885,1.885,0,0,1-.76-.621h-.061a7.538,7.538,0,0,1,.061.93v2.306h-.848v-8.12h.69l.117.767h.041a1.973,1.973,0,0,1,.762-.665,2.314,2.314,0,0,1,1-.2,2.071,2.071,0,0,1,1.721.762,4.058,4.058,0,0,1-.01,4.283A2.076,2.076,0,0,1,481.975,378.741Zm-.123-5.088a1.5,1.5,0,0,0-1.242.476,2.448,2.448,0,0,0-.394,1.514v.189a2.8,2.8,0,0,0,.394,1.69,1.5,1.5,0,0,0,1.263.509,1.314,1.314,0,0,0,1.138-.588,2.79,2.79,0,0,0,.411-1.621,2.685,2.685,0,0,0-.411-1.608A1.355,1.355,0,0,0,481.853,373.653Z",
    transform: "translate(-479.368 -370.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M515.793,367.659h-.849V359.7h.849Z",
    transform: "translate(-508.894 -359.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M529.763,378.688l-.169-.8h-.041a2.351,2.351,0,0,1-.836.713,2.539,2.539,0,0,1-1.04.187,1.872,1.872,0,0,1-1.306-.429,1.566,1.566,0,0,1-.473-1.222q0-1.7,2.715-1.779l.951-.031v-.347a1.419,1.419,0,0,0-.284-.974,1.166,1.166,0,0,0-.907-.315,3.7,3.7,0,0,0-1.585.43l-.261-.65a3.986,3.986,0,0,1,.908-.353,3.926,3.926,0,0,1,.989-.128,2.135,2.135,0,0,1,1.486.445,1.859,1.859,0,0,1,.483,1.427v3.824Zm-1.917-.6a1.724,1.724,0,0,0,1.245-.435,1.609,1.609,0,0,0,.453-1.217v-.506l-.849.035a3.088,3.088,0,0,0-1.46.315.948.948,0,0,0-.447.867.873.873,0,0,0,.279.7A1.155,1.155,0,0,0,527.845,378.09Z",
    transform: "translate(-517.984 -370.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M555.222,373.533h.91l1.227,3.2a12.215,12.215,0,0,1,.5,1.58h.041q.066-.261.278-.893t1.388-3.883h.911l-2.409,6.381a3.183,3.183,0,0,1-.836,1.343,1.778,1.778,0,0,1-1.173.4,3.435,3.435,0,0,1-.767-.087v-.68a2.963,2.963,0,0,0,.629.061,1.3,1.3,0,0,0,1.248-.982l.312-.8Z",
    transform: "translate(-542.321 -371.181)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(26.398 10.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M380.915,374.535a1.909,1.909,0,0,1-.153,3.247.825.825,0,0,0-.328.575.643.643,0,0,0,.305.5l.422.328a2.041,2.041,0,0,1,.984,1.642c0,1.1-1.067,2.215-3.082,2.215-1.7,0-2.52-.808-2.52-1.677a1.687,1.687,0,0,1,.9-1.43,5.053,5.053,0,0,1,2.239-.539,1.226,1.226,0,0,1-.352-.8,1.058,1.058,0,0,1,.117-.458c-.129.012-.258.024-.376.024a1.853,1.853,0,0,1-1.945-1.84,2.109,2.109,0,0,1,.75-1.571,3.2,3.2,0,0,1,2.1-.645h2.414l-.75.422Zm-.832,5.2a1.828,1.828,0,0,0-.269-.012,4.688,4.688,0,0,0-1.231.188,1.317,1.317,0,0,0-1.008,1.207c0,.832.809,1.43,2.063,1.43,1.125,0,1.723-.54,1.723-1.266C381.361,380.688,380.974,380.373,380.083,379.74Zm.34-2.227a1.186,1.186,0,0,0,.292-.856c0-.844-.5-2.156-1.476-2.156a1.1,1.1,0,0,0-.821.387,1.354,1.354,0,0,0-.258.867c0,.785.457,2.086,1.466,2.086A1.2,1.2,0,0,0,380.423,377.512Z",
    transform: "translate(-355.337 -371.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M344.928,378.74a2.762,2.762,0,0,1-2.855-2.762,2.9,2.9,0,0,1,3.031-2.843,2.736,2.736,0,0,1,2.8,2.762A2.859,2.859,0,0,1,344.928,378.74Zm1.463-.948a2.117,2.117,0,0,0,.351-1.3c0-1.03-.491-3-1.943-3a1.63,1.63,0,0,0-1.053.4,1.771,1.771,0,0,0-.539,1.428c0,1.158.574,3.065,1.99,3.065A1.5,1.5,0,0,0,346.391,377.793Z",
    transform: "translate(-326.73 -370.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M307.631,378.74a2.762,2.762,0,0,1-2.855-2.762,2.9,2.9,0,0,1,3.031-2.843,2.736,2.736,0,0,1,2.8,2.762A2.859,2.859,0,0,1,307.631,378.74Zm1.463-.948a2.12,2.12,0,0,0,.351-1.3c0-1.03-.492-3-1.943-3a1.631,1.631,0,0,0-1.053.4,1.771,1.771,0,0,0-.538,1.428c0,1.158.573,3.065,1.99,3.065A1.5,1.5,0,0,0,309.094,377.793Z",
    transform: "translate(-295.776 -370.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M259.962,365.631l-1.682.388a12.466,12.466,0,0,1-1.941.2,4.181,4.181,0,0,1-4.483-4.259,4.447,4.447,0,0,1,4.753-4.4,6.775,6.775,0,0,1,1.8.247,4.587,4.587,0,0,1,1.553.729l-.977.929-.412.094.294-.471a3.363,3.363,0,0,0-2.517-1.105,3.25,3.25,0,0,0-3.259,3.471,4.161,4.161,0,0,0,4.165,4.294,3.505,3.505,0,0,0,1.494-.294V363.56l-1.776.094.941-.506h2.494l-.305.294a.275.275,0,0,0-.118.188c-.012.106-.023.448-.023.565Z",
    transform: "translate(-251.856 -357.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M411.92,364.013c-.388-.035-.47-.106-.47-.565v-6.659c0-.025,0-.051.006-.076.047-.412.165-.482.53-.694H410.3l-.883.424h.9v7.265c0,.235-.046.27-.317.623h2.083l.435-.258C412.321,364.048,412.12,364.036,411.92,364.013Z",
    transform: "translate(-382.624 -356.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M431.455,378.344c-.128.07-.257.153-.385.21a2.722,2.722,0,0,1-1.135.222,2.5,2.5,0,0,1-1.554-.456,3.024,3.024,0,0,1-1.191-2.466,2.648,2.648,0,0,1,2.676-2.7,2.272,2.272,0,0,1,1.2.327,1.934,1.934,0,0,1,.817,1.156l-2.745,1.11-.9.07a2.6,2.6,0,0,0,2.407,2.348,3.019,3.019,0,0,0,1.425-.408Zm-1.1-3.482c.221-.082.338-.152.338-.315a1.159,1.159,0,0,0-1.157-1,1.439,1.439,0,0,0-1.344,1.624c0,.2.023.409.036.62Z",
    transform: "translate(-397.371 -370.241)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337",
    transform: "translate(34.863 2.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M457.195,373.236v.771H457.1v-.771h-.255v-.08h.6v.08Z",
    transform: "translate(-456.846 -373.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M461.941,374.007v-.778h0l-.238.778h-.073l-.24-.778h0v.778H461.3v-.851h.146l.217.688h0l.213-.688h.148v.851Z",
    transform: "translate(-460.541 -373.156)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339",
    transform: "translate(26.418 5.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M254.291,332.482h-.585a3.878,3.878,0,0,0-.166-.683H252.7a3.534,3.534,0,0,0-.172.683h-.55q0-.071.427-1.169a9.194,9.194,0,0,0,.427-1.209h.69a10.093,10.093,0,0,0,.386,1.192A10.429,10.429,0,0,1,254.291,332.482Zm-.844-1.032a10.347,10.347,0,0,1-.312-1.02H253.1a10.691,10.691,0,0,1-.323,1.02Z",
    transform: "translate(-251.974 -330.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M269.88,332.482h-.451a4.443,4.443,0,0,0-.5-.791,4.36,4.36,0,0,1-.6-1.032H268.3a6.448,6.448,0,0,1,.046.723q0,.451.025,1.1h-.449q.028-.566.027-1.244t-.027-1.134h.543a3.434,3.434,0,0,0,.451.773,4.548,4.548,0,0,1,.552.974h.027a6.935,6.935,0,0,1-.044-.731q0-.495-.026-1.016h.457q-.026.453-.026,1.134T269.88,332.482Z",
    transform: "translate(-265.208 -330.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M285.21,331.156a1.347,1.347,0,0,1-.333.906,1.161,1.161,0,0,1-.932.387q-.27,0-.745-.022.024-.552.024-1.244,0-.665-.024-1.134h.32q.079,0,.234-.006l.2-.005a1.232,1.232,0,0,1,.956.329A1.137,1.137,0,0,1,285.21,331.156Zm-.5.079a.88.88,0,0,0-.2-.591.775.775,0,0,0-.625-.24,1.92,1.92,0,0,0-.216.016q.018.365.018.764,0,.437.018.866a1.207,1.207,0,0,0,.238.024.69.69,0,0,0,.582-.244A.941.941,0,0,0,284.711,331.235Z",
    transform: "translate(-277.889 -329.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M299.977,332.428h-.541a3.587,3.587,0,0,0-.325-.8.426.426,0,0,0-.365-.152l-.2,0q0,.47.016.948h-.508q.024-.552.024-1.244,0-.665-.024-1.134h.316l.229-.006q.174-.005.322-.005.839,0,.839.574a.644.644,0,0,1-.479.634v.027a.571.571,0,0,1,.324.288A6.371,6.371,0,0,1,299.977,332.428Zm-.685-1.681q0-.364-.468-.364a1.593,1.593,0,0,0-.3.026q.02.283.02.738l.17,0Q299.291,331.151,299.292,330.747Z",
    transform: "translate(-290.215 -329.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M313.423,330.98a1.312,1.312,0,0,1-.343.93,1.115,1.115,0,0,1-.85.369,1.073,1.073,0,0,1-.807-.339,1.193,1.193,0,0,1-.325-.861,1.311,1.311,0,0,1,.343-.93,1.114,1.114,0,0,1,.85-.369,1.075,1.075,0,0,1,.807.338A1.193,1.193,0,0,1,313.423,330.98Zm-.5.053a.943.943,0,0,0-.2-.619.6.6,0,0,0-.482-.238.557.557,0,0,0-.453.239.955.955,0,0,0-.186.6.941.941,0,0,0,.2.618.6.6,0,0,0,.481.238.556.556,0,0,0,.453-.24A.956.956,0,0,0,312.918,331.033Z",
    transform: "translate(-301.042 -329.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M328.322,332.482H327.8q.024-.566.024-1.244T327.8,330.1h.517q-.024.46-.024,1.134T328.322,332.482Z",
    transform: "translate(-314.908 -330.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M336.609,331.156a1.347,1.347,0,0,1-.332.906,1.161,1.161,0,0,1-.932.387q-.27,0-.745-.022.024-.552.024-1.244,0-.665-.024-1.134h.32q.079,0,.234-.006l.2-.005a1.232,1.232,0,0,1,.956.329A1.138,1.138,0,0,1,336.609,331.156Zm-.5.079a.881.881,0,0,0-.2-.591.776.776,0,0,0-.625-.24,1.916,1.916,0,0,0-.216.016q.018.365.018.764,0,.437.018.866a1.206,1.206,0,0,0,.238.024.69.69,0,0,0,.582-.244A.941.941,0,0,0,336.11,331.235Z",
    transform: "translate(-320.547 -329.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M355.767,332.482h-.585a3.863,3.863,0,0,0-.167-.683h-.844a3.524,3.524,0,0,0-.172.683h-.55q0-.071.427-1.169a9.172,9.172,0,0,0,.427-1.209h.69a10.081,10.081,0,0,0,.387,1.192A10.48,10.48,0,0,1,355.767,332.482Zm-.844-1.032a10.37,10.37,0,0,1-.313-1.02h-.029a10.661,10.661,0,0,1-.323,1.02Z",
    transform: "translate(-336.192 -330.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M371.132,330.672a.712.712,0,0,1-.324.645,1.442,1.442,0,0,1-.8.208q-.086,0-.122,0,0,.343.02.906H369.4q.024-.528.024-1.244,0-.658-.024-1.134h.318l.259-.006q.192-.005.332-.005a1.045,1.045,0,0,1,.586.157A.531.531,0,0,1,371.132,330.672Zm-.471.1q0-.391-.519-.391a1.466,1.466,0,0,0-.274.027q.02.345.02.782c.03,0,.066,0,.106,0Q370.66,331.194,370.66,330.772Z",
    transform: "translate(-349.426 -329.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M384.016,330.672a.712.712,0,0,1-.324.645,1.444,1.444,0,0,1-.8.208c-.057,0-.1,0-.122,0q0,.343.02.906h-.513q.024-.528.024-1.244,0-.658-.024-1.134h.318l.26-.006q.192-.005.333-.005a1.045,1.045,0,0,1,.586.157A.531.531,0,0,1,384.016,330.672Zm-.471.1q0-.391-.519-.391a1.464,1.464,0,0,0-.274.027q.02.345.02.782.046,0,.106,0Q383.544,331.194,383.544,330.772Z",
    transform: "translate(-360.119 -329.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M402.2,330.98a1.312,1.312,0,0,1-.344.93,1.114,1.114,0,0,1-.849.369,1.074,1.074,0,0,1-.807-.339,1.194,1.194,0,0,1-.325-.861,1.312,1.312,0,0,1,.343-.93,1.115,1.115,0,0,1,.85-.369,1.075,1.075,0,0,1,.807.338A1.193,1.193,0,0,1,402.2,330.98Zm-.5.053a.942.942,0,0,0-.2-.619.6.6,0,0,0-.482-.238.557.557,0,0,0-.453.239.955.955,0,0,0-.186.6.941.941,0,0,0,.2.618.6.6,0,0,0,.481.238.556.556,0,0,0,.453-.24A.955.955,0,0,0,401.7,331.033Z",
    transform: "translate(-374.721 -329.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M418.544,332.482h-.451a4.443,4.443,0,0,0-.5-.791,4.362,4.362,0,0,1-.6-1.032h-.029a6.483,6.483,0,0,1,.046.723q0,.451.026,1.1h-.449q.027-.566.027-1.244t-.027-1.134h.542a3.44,3.44,0,0,0,.451.773,4.55,4.55,0,0,1,.552.974h.027a6.889,6.889,0,0,1-.044-.731q0-.495-.026-1.016h.457q-.025.453-.025,1.134T418.544,332.482Z",
    transform: "translate(-388.589 -330.048)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayIconWhite);
export default __webpack_public_path__ + "static/media/google-play-icon-white.61e6de9a9b89160761ee47e3d126fef5.svg";
export { ForwardRef as ReactComponent };